import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { defaultValue } from '../model/caseCategory.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    caseCategories: [],
    caseCategory: defaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
const apiUrl = API_ROUTES.issues;
export const getCaseCategories = createAsyncThunk(apiUrl, async ({ page, size, sort, filter }) => {
    const requestUrl = `${apiUrl}?page=${page}&size=${size}&sort=${sort}${filter ? `&filter=${filter}` : ''}`;
    return axios.get(requestUrl);
});
export const getCaseCategory = createAsyncThunk('caseCategoryManagement/fetch_case_category', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get(requestUrl);
}, { serializeError: serializeAxiosError });
export const createCaseCategory = createAsyncThunk('caseCategoryManagement/create_case_category', async (entity) => {
    const result = await axios.post(apiUrl, entity);
    return result;
}, { serializeError: serializeAxiosError });
export const updateCaseCategory = createAsyncThunk('caseCategoryManagement/update_case_category', async (entity) => {
    const result = await axios.put(`${apiUrl}/${entity.id}`, entity);
    return result;
}, { serializeError: serializeAxiosError });
export const deleteCaseCategory = createAsyncThunk('caseCategoryManagement/delete_case_category', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete(requestUrl);
    return result;
}, { serializeError: serializeAxiosError });
export const CaseCategoryManagementSlice = createSlice({
    name: 'caseCategoryManagement',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getCaseCategory.fulfilled, (state, action) => {
            state.loading = false;
            state.caseCategory = action.payload.data;
        })
            .addCase(deleteCaseCategory.fulfilled, state => {
            state.updating = false;
            state.updateSuccess = true;
            state.caseCategory = defaultValue;
        })
            .addMatcher(isFulfilled(getCaseCategories), (state, action) => {
            state.loading = false;
            state.caseCategories = action.payload.data;
            state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
        })
            .addMatcher(isFulfilled(createCaseCategory, updateCaseCategory), (state, action) => {
            state.updating = false;
            state.loading = false;
            state.updateSuccess = true;
            state.caseCategory = action.payload.data;
        })
            .addMatcher(isPending(getCaseCategories, getCaseCategory), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.loading = true;
        })
            .addMatcher(isPending(createCaseCategory, updateCaseCategory, deleteCaseCategory), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.updating = true;
        })
            .addMatcher(isRejected(getCaseCategories, getCaseCategory, createCaseCategory, updateCaseCategory, deleteCaseCategory), (state, action) => {
            state.loading = false;
            state.updating = false;
            state.updateSuccess = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = CaseCategoryManagementSlice.actions;
export default CaseCategoryManagementSlice.reducer;
